// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GAzdYQ {
  width: 24px;
  height: 24px;
  flex: none;
  margin-right: auto;
}

.GAzdYQ button {
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
}

.hxPIrS {
  position: fixed;
  width: 220px;
  height: 180px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 8px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  background: var(--surface-neutral-white);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  z-index: 1000;
}

.nYSF8P {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
  padding: 8px;
  border: none;
  border-radius: 4px;
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.8;
  color: var(--text-neutral-dark);
  background: transparent;
  text-align: left;
  cursor: default;
  white-space: nowrap;
}

.vkLWW0 {
  color: var(--status-error);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/EmissorOrderList/MigrationPreviewOrderMenu.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".trigger {\n  width: 24px;\n  height: 24px;\n  flex: none;\n  margin-right: auto;\n}\n\n.trigger button {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n}\n\n.menu {\n  position: fixed;\n  width: 220px;\n  height: 180px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  background: var(--surface-neutral-white);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);\n  z-index: 1000;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  gap: 8px;\n  padding: 8px;\n  border: none;\n  border-radius: 4px;\n  font-family: var(--font-family-base);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.8;\n  color: var(--text-neutral-dark);\n  background: transparent;\n  text-align: left;\n  cursor: default;\n  white-space: nowrap;\n}\n\n.destructive {\n  color: var(--status-error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `GAzdYQ`,
	"menu": `hxPIrS`,
	"row": `nYSF8P`,
	"destructive": `vkLWW0`
};
module.exports = ___CSS_LOADER_EXPORT___;
